import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SpecialLoggerComponent from './SpecialLoggerComponent';
import { getModel } from '../selectors';
import * as actions from '../actions';

const SpecialLoggerContainer = (props) => {
	return <SpecialLoggerComponent {...props}/>;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return { model };
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const SpecialLoggerContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(SpecialLoggerContainer);

export default SpecialLoggerContainerConn;
